import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";

import __ from "web/Layout/Translations";

import ArrowLeftIcon from "web/assets/icons/arrow-left.svg";
import ArrowRightIcon from "web/assets/icons/arrow-right.svg";

import { GA_GTM_CATEGORY_CLICK_ACTIONS } from "web/utils/system/GTM/sendGaGtmEvent";
import {
  trackCategoryClick,
  trackCategoryCollapse,
} from "web/utils/system/GTM/navigationGtmEvents";

import type { ICategory } from "web/types/Category";

import classes from "./list.scss";
import getLink from "./utils/getLink";
import getParentCategoryId from "./utils/getParentCategoryId";

interface ISubcategoryViewProps {
  startCategoryData: ICategory;
  rootCategoryId: number;
  listItems: ReactNode[];
  onBack: (parentId: number | null) => void;
  onNavigate: () => void;
}

const SubcategoryView: FC<ISubcategoryViewProps> = ({
  startCategoryData,
  rootCategoryId,
  listItems,
  onBack,
  onNavigate,
}) => {
  const handleBackClick = () => {
    trackCategoryCollapse(startCategoryData.name);
    const parentId = getParentCategoryId(startCategoryData, rootCategoryId);
    onBack(parentId);
  };

  const allInLabel = __("Wszystkie w ") + startCategoryData.name;

  return (
    <div className={classes.subcategoryRoot}>
      <div className={classes.subcategory}>
        <button
          className={classes.subcategoryHeader}
          type="button"
          onClick={handleBackClick}
        >
          <ArrowLeftIcon width={10} />
          <span>{startCategoryData.name}</span>
        </button>
        <Link
          className={classes.navItem}
          to={getLink(startCategoryData.request_path)}
          onClick={() => {
            trackCategoryClick(
              GA_GTM_CATEGORY_CLICK_ACTIONS.MOBILE,
              `${startCategoryData.name} / ${allInLabel}`
            );
            onNavigate();
          }}
        >
          <span>{allInLabel}</span>
          <ArrowRightIcon width={10} />
        </Link>
        {listItems}
      </div>
    </div>
  );
};

export default SubcategoryView;
